/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text, useBreakpointValue } from "@aws-amplify/ui-react";
export default function Page0(props) {
  const { overrides: overridesProp, ...restProp } = props;
  const variants = [
    {
      variantValues: { breakpoint: "xxl" },
      overrides: { Title: {}, Subtitle: {}, Page0: {} },
    },
    {
      variantValues: { breakpoint: "xl" },
      overrides: {
        Title: { width: "unset", alignSelf: "stretch" },
        Subtitle: {},
        Page0: { width: "1280px", padding: "60px 200px 60px 200px" },
      },
    },
    {
      variantValues: { breakpoint: "large" },
      overrides: {
        Title: { width: "unset", alignSelf: "stretch" },
        Subtitle: {},
        Page0: { width: "992px", padding: "60px 200px 60px 32px" },
      },
    },
    {
      variantValues: { breakpoint: "medium" },
      overrides: {
        Title: { width: "unset", alignSelf: "stretch" },
        Subtitle: {},
        Page0: { width: "768px", padding: "60px 200px 60px 32px" },
      },
    },
    {
      variantValues: { breakpoint: "base" },
      overrides: {
        Title: {
          fontSize: "32px",
          lineHeight: "40px",
          textAlign: "center",
          width: "unset",
          alignSelf: "stretch",
        },
        Subtitle: { textAlign: "center" },
        Page0: { width: "375px", padding: "60px 16px 60px 16px" },
      },
    },
  ];
  const breakpointHook = useBreakpointValue({
    base: "base",
    medium: "medium",
    large: "large",
    xl: "xl",
    xxl: "xxl",
  });
  const rest = { style: { transition: "all 0.25s" }, ...restProp };
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, {
      breakpoint: breakpointHook,
      ...props,
    }),
    overridesProp || {}
  );
  return (
    <Flex
      gap="6px"
      direction="column"
      width="1536px"
      height="220px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      padding="60px 240px 60px 240px"
      backgroundColor="rgba(66,0,255,1)"
      display="flex"
      {...getOverrideProps(overrides, "Page0")}
      {...rest}
    >
      <Text
        fontFamily="IvyOra Display"
        fontSize="44px"
        fontWeight="700"
        color="rgba(255,255,255,1)"
        lineHeight="46px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        width="1032px"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="Submit a Ticket"
        {...getOverrideProps(overrides, "Title")}
      ></Text>
      <Text
        fontFamily="Manrope"
        fontSize="16px"
        fontWeight="700"
        color="rgba(255,255,255,1)"
        lineHeight="20px"
        textAlign="left"
        display="none"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="Optional Subtitle"
        {...getOverrideProps(overrides, "Subtitle")}
      ></Text>
    </Flex>
  );
}
